import { waitForTruthyVal } from '../helpers/utils';
import "../../styles/pages/_order-tracking.scss";
const spinner = document.querySelector('main loading-spinner');
try {
    // The below code will automatically parse the values from a URL like
    // https://yourwebsite.com/tracking?tracking_numbers=preview_intransit&carrier=generic
    // and pass them to the embedded script. Alternatively, these can be overridden and passed
    // directly into the object if the values are available on the client.
    const queryParameters = getQueryParameters();
    if (isOrderNumberPresent(queryParameters)) {
        handleCarrierData(queryParameters);
    }
    else {
        toggleFormContainer();
        console.log('Order number is required');
        hideSpinner();
    }
}
catch (err) {
    console.error(err);
}
document.addEventListener('DOMContentLoaded', () => {
    limitInputToAlphanumeric("tracking-info-orderId");
    const form = document.getElementById('orderTrackingForm');
    form.addEventListener('submit', function (event) {
        event.preventDefault();
        submitForm();
    });
    const iframeLoadedObserver = new MutationObserver((mutations, observerInstance) => {
        const iframe = mutations[0]?.addedNodes[0];
        if (iframe instanceof HTMLIFrameElement) {
            iframe.addEventListener('load', () => {
                hideSpinner();
            });
            observerInstance.disconnect();
        }
    });
    iframeLoadedObserver.observe(document.querySelector('[data-narvar-feature="track"]'), { childList: true });
});
function hideSpinner() {
    if (spinner) {
        spinner.setAttribute('show', 'false');
    }
}
function showSpinner() {
    if (spinner) {
        spinner.setAttribute('show', 'true');
    }
}
function getQueryParameters() {
    // the # in the order number causes the query parameters to be truncated
    if (window.location.href.includes("order_number=#")) {
        window.history.replaceState({}, document.title, window.location.href.replace("order_number=#", "order_number="));
    }
    return window
        .location
        .search
        .replace(/^\?/g, '')
        .split('&')
        .reduce((acc, param) => {
        const keyAndValue = param.split('=');
        acc[keyAndValue[0]] = keyAndValue[1];
        return acc;
    }, {});
}
/**
 *
 * @param {Error} error
 */
function handleCarrierError(error) {
    // Code here for cases where carrier is not resolved.
    const errorBox = document.getElementById('errorBox');
    errorBox.classList.remove("error-box-hidden");
    errorBox.classList.add("error-box-visible");
    const errorMessage = document.getElementById('errorMessage');
    errorMessage.textContent = error.message;
    hideSpinner();
    toggleFormContainer();
}
function hideCarrierError() {
    const errorBox = document.getElementById('errorBox');
    errorBox.classList.remove("error-box-visible");
    errorBox.classList.add("error-box-hidden");
    const errorMessage = document.getElementById('errorMessage');
    errorMessage.textContent = "";
}
/**
 *
 * @param {object} queryParameters
 * @param {object} data
 */
function processNarvarTracking(queryParameters, data) {
    console.log("Data is ", data);
    console.log("queryParameters is ", queryParameters);
    let trackingNumbers = data.tracking_number || data.trackingNumbers || data.tracking_numbers || queryParameters.tracking_numbers || "";
    trackingNumbers = trackingNumbers.replaceAll(" ", "");
    console.log("Tracking numbers are ", trackingNumbers);
    waitForTruthyVal(() => window.narvar).then((narvar) => {
        const payload = {
            retailer: window.UNTUCKitConfig.thirdPartyToggles.narvarOrderTrackingRetailer,
            locale_language: queryParameters.locale_language,
            locale_country: queryParameters.locale_country,
            tracking_numbers: trackingNumbers,
            carrier: data.carrier || data.firstCarrier,
            order_number: queryParameters.order_number || queryParameters.newstore_order_id,
            t: queryParameters.t,
            version_name: window.UNTUCKitConfig.thirdPartyToggles.narverOrderTrackingVersionName,
            ...queryParameters,
        };
        // quick fix for when carrier information is missing (see: https://app.asana.com/0/1203119262658048/1208811327652563/f)
        if (!payload.carrier && isFedexTrackingNumber(payload.tracking_numbers.split(",")[0])) {
            payload.carrier = "FedEx";
        }
        // quick fix for when carrier is FEDEX_SMART_POST or something similar
        if (payload.carrier?.toLowerCase().includes("fedex")) {
            payload.carrier = "FedEx";
        }
        narvar('track', payload);
    });
}
function toggleFormContainer() {
    const formContainer = document.getElementsByClassName('order-tracking-hidden-container')[0];
    formContainer.style.display = (formContainer.style.display === "block") ? "none" : "block";
}
/**
 *
 * @param {object} queryParameters
 * @returns
 */
function isOrderNumberPresent(queryParameters) {
    // Returns true or false using truthy/falsy values.
    return !!queryParameters.order_number ||
        !!queryParameters.newstore_order_id ||
        (!!queryParameters.tracking_numbers && !!queryParameters.carrier);
}
/**
 *
 * @param {object} queryParameters
 * @returns
 */
async function getOrderInformation(queryParameters) {
    const baseUrl = window.UNTUCKitConfig.newstoreCarrierUrl;
    let url = "";
    if (queryParameters.newstore_order_id) {
        url = `${baseUrl}?newstore_order_id=${queryParameters.newstore_order_id}&tracking_number=${queryParameters.tracking_numbers}`;
    }
    if (queryParameters.email) {
        url += `&email=${queryParameters.email}`;
    }
    const response = await fetch(url);
    if (!response.ok) {
        const errorData = await response.json();
        console.error('error when requesting newstore order tracking data', errorData);
        const errorCode = errorData?.error?.code;
        if (errorCode) {
            console.error(`error code: ${errorCode}`);
        }
        throw new Error(errorData.message || errorData.error.message || 'There was a problem finding your order. Please contact customers service.');
    }
    const data = await response.json();
    return data;
}
/**
 *
 * @param {object} queryParameters
 * @returns
 */
async function fetchAndProcessCarrier(queryParameters) {
    if ("newstore_order_id" in queryParameters) {
        return await getOrderInformation(queryParameters);
    }
    else {
        return queryParameters;
    }
}
/**
 *
 * @param {object} queryParameters
 */
function handleCarrierData(queryParameters) {
    fetchAndProcessCarrier(queryParameters)
        .then((data) => {
        processNarvarTracking(queryParameters, data);
    })
        .catch((error) => {
        handleCarrierError(error);
    });
}
/**
 *
 * @param {string} orderNumber
 * @returns
 */
function isOnlineOrder(orderNumber) {
    if (!orderNumber) {
        return false;
    }
    const firstTwoCharacters = orderNumber.slice(0, 2);
    if (firstTwoCharacters.toLowerCase() === "un") {
        return false;
    }
    return true;
}
function submitForm() {
    const email = document.getElementById('tracking-info-email')?.value;
    let orderNumber = document.getElementById('tracking-info-orderId')?.value;
    // Strip first character from orderNumber if it is a #.
    if (orderNumber.charAt(0) === "#") {
        orderNumber = orderNumber.slice(1);
    }
    // create a queryParameters object that has both email and orderNumber in it.
    const queryParameters = getQueryParameters();
    queryParameters.email = email;
    if (isOnlineOrder(orderNumber)) {
        queryParameters.order_number = orderNumber;
        // Bypass getting order information and go straight to Narvar.
        showSpinner();
        processNarvarTracking(queryParameters, {});
        toggleFormContainer();
        hideCarrierError();
    }
    else {
        queryParameters.newstore_order_id = orderNumber;
        // Get order information and then pass it to Narvar.
        showSpinner();
        handleCarrierData(queryParameters);
        toggleFormContainer();
        hideCarrierError();
    }
}
/**
 *
 * @param {string} id
 * @returns
 */
function limitInputToAlphanumeric(id) {
    const inputField = document.getElementById(id);
    if (!inputField) {
        console.error("Input field with id 'test_id' not found.");
        return;
    }
    inputField.addEventListener('input', function (event) {
        const target = event.target;
        const inputValue = target.value;
        const filteredValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');
        target.value = filteredValue;
    });
}
/**
 *
 * @param {string} str
 * @returns
 */
function isFedexTrackingNumber(str) {
    const fedexRegex = /^\d{12}$/;
    return fedexRegex.test(str);
}
